import React from 'react'
import styled from 'styled-components'
import Breakpoints from '../../../constants/breakpoints'

interface Props {
  placeholder: string
  title?: string
  name: string
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>
  questionId: string
  value: string
}

const TextArea: React.FC<Props> = ({
  placeholder,
  title,
  onChange,
  name,
  questionId,
  value
}) => (
  <TextareaContainer>
    {title && (
      <Title>
        <label htmlFor={name} dangerouslySetInnerHTML={{ __html: title }}></label>
      </Title>
    )}
    <StyledTextarea
      placeholder={placeholder}
      name={name}
      id={name}
      onChange={onChange}
      value={value}
      aria-labelledby={questionId}
    />
  </TextareaContainer>
)

const TextareaContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

const Title = styled.h2`
  border: solid 1px ${({ theme }) => theme.lightGrey};
  border-bottom: none;
  font-size: 1.25rem;
  font-weight: 800;
  text-align: left;
  border-radius: 4px 4px 0 0;
  position: relative;
  z-index: 10;
  background: white;
  margin: 0;

  & label {
    display: block;
    padding: 20px;
  }

  & span {
    text-decoration: underline;
  }

  & + textarea {
    border-radius: 0 0 4px 4px;
  }
`

const StyledTextarea = styled.textarea`
  display: block;
  font-size: 1.125rem;
  min-height: 150px;
  min-width: calc(100vw - 80px);
  width: 100%;
  padding: 20px;
  font-family: 'Circular', sans-serif;
  border: solid 1px ${({ theme }) => theme.lightGrey};
  box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  transition: all 0.3s ease;

  @media (min-width: ${Breakpoints.md}) {
    min-width: 400px;
  }

  &::placeholder {
    color: ${({ theme }) => theme.textColor};
    opacity: 0.5;
  }

  &:focus {
    outline: none;
    box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.32);
  }

`

export default TextArea
